export const parseLocalDate = (date: string): Date => {
  const [year, month, day] = date.split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const isToday = (date: string) => {
  const d = parseLocalDate(date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return d.getTime() === today.getTime();
};

export const isThisWeek = (date: string) => {
  const d = parseLocalDate(date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const weekFromNow = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000);
  return d >= today && d <= weekFromNow;
};

export const isOverdue = (date: string) => {
  const [year, month, day] = date.split("-").map(Number);
  const dueDate = new Date(year, month - 1, day); // month is 0-indexed
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return dueDate < today;
};
